import React from 'react'

const Heroheader = () => {
  return (
    <> <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white mb-3 animated slideInDown">Save lifes With Us</h1>
          <p className="fs-4 text-white mb-4 animated slideInDown">"Preparing for the worst, managing the present, and adapting for the future". <br />Sankatmochak</p>

        </div>
      </div>
    </div>
  </div></>
  )
}

export default Heroheader